<template>
    <v-card class="statisticsHorizontalBarComponent pa-3 pt-0">
        <v-card-title>
            {{ $t("title_" + dataKey) }}
            <infoTooltip v-if="tooltip" :tooltip="tooltip" />
        </v-card-title>
        <v-card-text>
            <v-skeleton-loader v-if="stats[dataKey] === undefined" type="article"></v-skeleton-loader>

            <div v-else-if="graphData.datasets && graphData.labels.length" v-for="(item, index) in graphData.labels" :key="'lead-type-' + index" class="mb-4">
                <div class="d-flex justify-space-between align-center mb-1">
                    <span class="font-weight-medium">{{ item }}</span>
                    <span class="text-caption">{{ graphData.datasets[0].data[index] }} | {{ Math.round((graphData.datasets[0].data[index] / getDataTotal(graphData.datasets[0].data)) * 100) }}%</span>
                </div>
                <v-progress-linear
                    :value="(graphData.datasets[0].data[index] / getDataTotal(graphData.datasets[0].data)) * 100"
                    height="8"
                    color="#0058FE"
                    background-color="grey lighten-3"
                    rounded
                ></v-progress-linear>
            </div>
            
            <v-alert class="mb-0" border="left" color="info" v-else text>
                {{ $t("emptyDataMessage") }}
            </v-alert>
        </v-card-text>
    </v-card>
</template>

<script>
import infoTooltip from '@/components/infoTooltip';

export default {
    name: "statisticsHorizontalBarComponent",
    props: ["stats", "dataKey", "to_trad", "tooltip"],
    components: { infoTooltip },
    data() {
        return {
            graphData: {},
        }
    },
    watch: {
        stats: {
            handler() {
                this.generateGraphData();
            },
            deep: true,
        }
    },
    methods: {
        generateGraphData() {
            if(this.stats && this.stats[this.dataKey] !== undefined) {
                let labels = Object.keys(this.stats[this.dataKey]);

                if(this.to_trad) {
                    labels = labels.map(label => this.$t(label));
                }

                this.graphData = {
                    "labels": labels,
                    "datasets": [{
                        "data": Object.values(this.stats[this.dataKey]),
                    }]
                }
            }
        },
        getDataTotal(datas) {
            return datas.reduce((a, b) => parseInt(a) + parseInt(b), 0);
        }
    },
}
</script>

<style lang="scss">
    .statisticsHorizontalBarComponent {

    }
</style>